import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'

const LinkModal = ({ isOpen, onClose, onSave, selectedText, link, setLink }) => {
  // const [link, setLink] = useState('')
  const [error, setError] = useState('')

  const handleSave = () => {
    // Basic URL validation
    if (link.trim() !== '' && isValidURL(link)) {
      onSave(link)
      onClose()
    } else {
      setError('Please enter a valid URL')
    }
  }

  const isValidURL = url => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~()+]*)*' + // port and path (added "()")
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
      'i',
    )
    // fragment locator
    // console.log(pattern.test(url), 'url===')
    return Boolean(pattern.test(url))
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Enter the Link</Modal.Title>
        <br/>
      </Modal.Header>
      <Modal.Body>
        <div>
        SelectedText:
        <span>{selectedText}</span>
        <input
          type='text'
          placeholder='Enter the link'
          value={link}
          className='form-control'
          onChange={e => setLink(e.target.value.trim())}
          />
          </div>
        {error && <p className='mandatory1'>{error}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
        <Button variant='primary' onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default LinkModal
